import { useContrastMutation } from '../../../hooks/use-contrast-mutation'
import { UseMutationOptions } from 'react-query'
import { BulkRouteActionByFiltersArgs } from '../api/shared'
import { bulkDeleteRoutesByFilters } from '../api/bulk-delete-routes-by-filters'
import { HTTPError } from '../../../api/fetch/decorate-fetch'

interface Response {
  readonly success: boolean
  readonly messages: string[]
}

export function useBulkDeleteRoutesByFiltersMutation(
  options?: UseMutationOptions<
    Response,
    HTTPError,
    BulkRouteActionByFiltersArgs
  >
) {
  return useContrastMutation<Response, HTTPError, BulkRouteActionByFiltersArgs>(
    bulkDeleteRoutesByFilters,
    options
  )
}
